module.exports = __webpack_public_path__ + "img/planet.56f5b940.png";